import React, { useRef, useState } from "react";
import { updateData } from "../hooks/update";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function LoginPage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function formSubmitHandler(event) {
    event.preventDefault();
    setLoading(true);
    sessionStorage.clear();
    // verify inputs
    let data = {};
    [...event.target].map((item) => {
      if (item.name) data[item.name] = item.value;
    });
    if (data?.email && data?.password) {
      await updateData("user/login", data, null, true, true, navigate, null);
      setLoading(false);
    }
  }

  return (
    <div className="bg-[#1D1F20] bg-image p-8 text-gray-50 w-full h-screen flex items-center justify-center flex-col">
      <div className="p-8 w-full itc justify-center flex -mt-28">
        <img
          src="https://banglahaat.net/logo_white.svg"
          alt="logo"
          className="w-40"
        />
      </div>
      <div className="max-w-[28rem] px-[2rem] py-[3rem] lg:p-[3rem] bg-[#212324] shadow-sm border border-gray-500 border-dashed rounded-xl">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <h1 className="font-nunito text-4xl max-[440px]:text-3xl sm:text-4xl text-center mb-8">
          Sign in
        </h1>
        <form onSubmit={formSubmitHandler}>
          <input
            type="text"
            name="email"
            id="login-email"
            placeholder="Username"
            className="w-full my-2 darkPrimary border border-gray-600 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
            required
          />
          <input
            type="password"
            name="password"
            id="password"
            autoComplete="current-password"
            placeholder="Enter the password"
            className="w-full my-2 darkPrimary border border-gray-600 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
            required
          />
          <button
            disabled={loading}
            className="py-2.5 w-full rounded-md text-center font-semibold text-base border mt-12 border-dashed border-gray-600 text-gray-300 uppercase hover:border-secondary hover:bg-secondary transition-colors duration-150 disabled:bg-gray-800 disabled:hover:border-gray-800 disabled:border-gray-800 disabled:cursor-not-allowed disabled:text-gray-500"
          >
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
